import { TASK_INTERVAL } from '../types/server/models/task'

export const TIME_UNITS: {
	[key in TASK_INTERVAL]: number
} = {
	MINUTE: 1000 * 60,
	DAY: 1000 * 60 * 60 * 24 * 1,
	WEEK: 1000 * 60 * 60 * 24 * 7,
	MONTH: 1000 * 60 * 60 * 24 * 30,
	YEAR: 1000 * 60 * 60 * 24 * 365,
}

/**
 * Convert interval and amount to milliseconds
 */
export const ConvertIntervalToMS = (interval: TASK_INTERVAL, amount: number) => {
	const timeUnit = TIME_UNITS[interval]
	if (!timeUnit) {
		throw new Error(`Invalid interval: ${interval}`)
	}

	const milliseconds = timeUnit * amount
	return milliseconds
}
